import { render, staticRenderFns } from "./TopMadeOutsBox.vue?vue&type=template&id=ec498366&scoped=true"
import script from "./TopMadeOutsBox.vue?vue&type=script&lang=js"
export * from "./TopMadeOutsBox.vue?vue&type=script&lang=js"
import style0 from "./TopMadeOutsBox.vue?vue&type=style&index=0&id=ec498366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec498366",
  null
  
)

export default component.exports